<template>
  <div class="container container-table">
      <div class="row">
        <div class="container">
          <img src="/static/img/logo2.jpeg" class="center-block logo">
          <div class="text-center col-md-4 col-sm-offset-4">
            <!-- login form -->
            <form class="ui form loginForm"  @submit.prevent="checkCreds">

              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                <input class="form-control" name="username" placeholder="Username" type="text" v-model="username">
              </div>

              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-lock"></i></span>
                <input class="form-control" name="password" placeholder="Password" type="password" v-model="password">
              </div>
              <router-link to="redefinir-senha">
                Esqueceu sua senha?
              </router-link><br><br>
              <button id="btn" type="submit" class="btn btn-primary btn-lg" >
                <div v-show="loading"><i class="fa fa-spinner fa-spin"></i>Entrando</div>
                <div v-show="!loading">Entrar</div>
              </button>
            </form>
            <!-- errors -->
            <div v-if="response" class="text-red"><p>{{response}}</p></div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import router from '../router'
import $ from 'jquery'
import crypto from 'crypto'
import config from '../config'
export default {
  name: 'Login',
  data (router) {
    return {
      username: '',
      password: '',
      response: '',
      classeBtn: '',
      loading: false
    }
  },
  created () {
    
    
  },
  methods: {
    checkCreds () {
      this.loading = true
      $('#btn').addClass('disabled')
      this.$store.commit('TOGGLE_LOADING')
      firebase.auth().signInWithEmailAndPassword(this.username, this.password).then(
        (user) => {
          const criptografada = this.criptografar(this.password);
          window.localStorage.setItem('password', criptografada);
          window.localStorage.setItem('usuario', this.username);
          router.replace('/')
        },
        (Error) => {
          this.loading = false
          $('#btn').removeClass('disabled')          
          $('#btn').addClass('animated shake')
          this.response = Error.message
          setTimeout(function(){
                $('#btn').removeClass('animated shake')
            }, 1000);
        }
      )
    },
    criptografar(senha) {
      const cipher = crypto.createCipher(config.DADOS_CRIPTOGRAFAR.algoritmo, config.DADOS_CRIPTOGRAFAR.segredo);
      cipher.update(senha);
      return cipher.final(config.DADOS_CRIPTOGRAFAR.tipo);
    }
  }
}
</script>

<style>
html, body, .container-table {
  height: 100%;
  background-color: white !important;
}
.container-table {
    display: table;
    color: white;
}
.vertical-center-row {
    display: table-cell;
    vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.logo {
  width: 15em;
  padding: 3em;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
}
.input-group input {
  height: 4em;
}

</style>



// WEBPACK FOOTER //
// Login.vue?d06b6e3a